module.exports = __webpack_public_path__ + "static/img/lj7.ede94e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lj7.png
// module id = UXR/
// module chunks = 3